import React, {
  createContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';


// dummy data for dev
import axios from 'axios';
import { Navigate, useNavigate } from 'react-router-dom';
import useLocalStorage from '../hooks/localStorage';
import { IUser, IUserContext } from '../models/interfaces';
interface Props {
  children?: ReactNode;
}

export const UserContext = createContext({} as IUserContext);

export const UserContextProvider: React.FC<Props> = (props) => {
  const [user, setUser] = useState<IUser>({} as IUser);
  const [token, setToken] = useState<string>('');
  const [isAdmin, setIsAdmin] = useState<boolean>(true)
 const [storedToken, setStoredToken] = useLocalStorage<string>('token', '');
 const [storedUser, setStoredUser] = useLocalStorage<string>('user', '')
  useEffect(() => {
    if(storedToken) {
      console.log('setting token')
      setToken(storedToken);
    }
    if(storedUser) {
      const tempUser = JSON.parse(storedUser);
      setUser(tempUser as IUser)
    }
  }, [])
  const getSignIn = async (email: string, password: string, save: boolean) => {
  console.log('email', email);
  console.log('password', password);
    try{
      const result = await axios.get(`${process.env.REACT_APP_API}/signin`, {auth: {
          username: email,
          password: password,
        }});
        setUser(result.data.user);
        setToken(result.data.token);
        if(save) {
          setStoredToken(result.data.token)
          setStoredUser(JSON.stringify(result.data.user))
        }
        // navigate('/app/landing')
      console.log('user signed in', result);
    } catch(e) {
      console.log('signin error', e);
    }

  }

  const logout = () => {
    setToken('');
    setUser({} as IUser);
    setStoredToken('');
    setStoredUser('')
  }

  const createAccount = async (username: string, password: string, name: string) => {
    const result = await axios.post(`${process.env.REACT_APP_API}/signup`, 
    {username, password, name});
    if(result.status === 201) {
     setToken(result.data.token);
     setUser(result.data.user);

    }
  }

  const auth = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };



  

  
  
 


  

  const value = {
    user,
    token,
    getSignIn,
    logout,
    auth, 
    createAccount,
    isAdmin
  }
   
  return (
    <UserContext.Provider value={value}>
      {props.children}
    </UserContext.Provider>
  );
};
